import { ResetPasswordPage } from 'auth/pages'

export default function ResetPassword() {
  return <ResetPasswordPage />
}
